import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-2xl bg-[#0f172a] border border-white/10 p-6 shadow-xl" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = { class: "grid grid-cols-1" }
const _hoisted_4 = { class: "flex justify-end gap-3 mt-6" }
const _hoisted_5 = {
  key: 0,
  class: "py-2 text-red-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-1",
        onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-lg font-semibold" }, "Let’s Talk", -1)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
              class: "text-white/60 hover:text-white text-xl"
            }, " ✕ ")
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "grid grid-cols-1 flex mb-6" }, [
            _createElementVNode("p", { class: "mt-1" }, "Questions, feedback, or ideas? Send us a message.")
          ], -1)),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                id: "text",
                ref: "inputText",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.item.title) = $event)),
                type: "text",
                required: "",
                placeholder: "Title",
                maxlength: "255",
                class: "input rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"
              }, null, 512), [
                [_vModelText, $setup.data.item.title]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.item.email) = $event)),
                type: "text",
                required: "",
                placeholder: "Email",
                maxlength: "255",
                class: "input rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"
              }, null, 512), [
                [_vModelText, $setup.data.item.email]
              ]),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.item.message) = $event)),
                rows: "3",
                maxlength: "4096",
                placeholder: "Enter your message here...",
                class: "input resize-none rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"
              }, null, 512), [
                [_vModelText, $setup.data.item.message]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              ($setup.data.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.data.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
                class: "px-4 py-2 rounded-lg text-white/70 hover:text-white"
              }, " Cancel "),
              _createElementVNode("button", {
                type: "button",
                class: "px-5 py-2 rounded-lg bg-cyan-400 text-black font-semibold hover:bg-cyan-300",
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
              }, " Send ")
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}